var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorOutlinedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11C13.66 11 15 9.65998 15 7.99998C15 6.33998 13.66 4.99998 12 4.99998C10.34 4.99998 9.00004 6.33998 9.00004 7.99998C9.00004 9.65998 10.34 11 12 11ZM12 6.99998C12.55 6.99998 13 7.44998 13 7.99998C13 8.54998 12.55 8.99998 12 8.99998C11.45 8.99998 11 8.54998 11 7.99998C11 7.44998 11.45 6.99998 12 6.99998Z",
    fill: "#858287"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C10.16 12 8.44004 12.5 6.97004 13.37C6.36004 13.72 6.00004 14.39 6.00004 15.09V17H18V15.09C18 14.39 17.64 13.73 17.03 13.37C15.56 12.5 13.84 12 12 12ZM8.14004 15C9.32004 14.35 10.65 14 12 14C13.35 14 14.68 14.35 15.85 15H8.14004Z",
    fill: "#858287"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.23 8.14998L23.08 7.37998C21.86 4.46998 19.53 2.12998 16.62 0.919983L15.85 2.76998C18.27 3.78998 20.21 5.72998 21.23 8.14998Z",
    fill: "#858287"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15004 2.76998L7.38004 0.919983C4.47004 2.13998 2.14004 4.46998 0.920044 7.37998L2.77004 8.14998C3.79004 5.72998 5.73004 3.78998 8.15004 2.76998Z",
    fill: "#858287"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77004 15.85L0.920044 16.62C2.14004 19.53 4.47004 21.87 7.38004 23.08L8.15004 21.23C5.73004 20.21 3.79004 18.27 2.77004 15.85Z",
    fill: "#858287"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.85 21.23L16.62 23.08C19.53 21.86 21.87 19.53 23.08 16.62L21.23 15.85C20.21 18.27 18.27 20.21 15.85 21.23Z",
    fill: "#858287"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorOutlinedIcon);
export default __webpack_public_path__ + "static/media/sensor-outlined-icon.4766ca4f5d4451ad686fd9c6ee04d880.svg";
export { ForwardRef as ReactComponent };